<template>
  <div>

    <v-card class="pa-5">

      <!-- HEADER -->
      <div class="d-flex justify-space-between align-center mb-5">
        <div class="text-center font-weight-bold" style="font-size:20px">
          Delivery Order Report
        </div>

        <v-btn color="success" @click="exportPDF" :disabled="!reportDetails">
          Export PDF
        </v-btn>
      </div>

      <!-- FORM -->
      <v-row>

        <!-- DELIVERY DATE -->
        <v-col cols="3" class="pt-5">Delivery Date</v-col>
        <v-col cols="3">
          <v-menu
            v-model="deliveryDateMenu"
            offset-y
            transition="scale-transition"
            max-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="deliveryDate"
                prepend-inner-icon="mdi-calendar"
                readonly
                dense
                outlined
                v-bind="attrs"
                v-on="on"
              />
            </template>

            <v-date-picker
              v-model="deliveryDate"
              @input="deliveryDateMenu = false"
              scrollable
            />
          </v-menu>
        </v-col>

        <!-- DO NUMBER -->
        <v-col cols="3" class="pt-5">Delivery Order</v-col>
        <v-col cols="3">
          <v-select
            :items="deliveryOrderData"
            item-text="do_no"
            return-object
            v-model="selectedDO"
            outlined
            dense
            :disabled="!deliveryDate"
          />
        </v-col>

        <!-- CUSTOMER -->
        <v-col cols="3" class="pt-5">Nama Customer</v-col>
        <v-col cols="9">
          <v-text-field
            v-model="customerName"
            readonly
            outlined
            dense
          />
        </v-col>

        <!-- ADDRESS -->
        <v-col cols="3" class="pt-5">Delivery Address</v-col>
        <v-col cols="9">
          <v-textarea
            v-model="deliveryAddress"
            readonly
            outlined
            dense
            rows="2"
          />
        </v-col>

        <!-- RUN BUTTON -->
        <v-col cols="12" class="text-right mt-5">
          <v-btn color="primary" @click="runReport" :disabled="!selectedDO">
            Run
          </v-btn>
        </v-col>

      </v-row>

      <!-- TABLE OUTPUT -->
      <v-card v-if="showTable" class="mt-5 pa-5">

            <v-simple-table fixed-header height="400px" ref="tableDO">
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th><b>Nama Variant</b></th>
                            <th><b>Label</b></th>
                            <th><b>Volume</b></th>
                        </tr>
                    </thead>
                    <tbody v-if="reportDetails && reportDetails.details">
                        <tr v-for="(item, index) in reportDetails.details" :key="index">
                            <td>{{ item.name }}</td>
                            <td>
                                <span style="display:none">
                                    {{ item && item.color && item.color.color ? item.color.color : '#ccc' }}
                                </span>
                                <div v-if="item && item.color && item.color.color"
                                    :style="{
                                    width: '25px',
                                    height: '25px',
                                    background:  item.color.color,
                                    border: '1px solid #999'
                                    }"
                                ></div>
                            </td>

                            <td>{{ item.size }} ML</td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>

        </v-card>


    </v-card>
    <vue-html2pdf
      ref="html2Pdf"
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      filename="Delivery-Order"
      :paginate-elements-by-height="1400"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
    >
      <section slot="pdf-content">
        <div class="pdf-wrapper">

          <div class="text-center font-weight-bold mb-4" style="font-size:20px">
            Delivery Order Report
          </div>

          <div class="mb-4" style="margin-bottom: 30px;">
            <div><b>No. Delivery Order:</b> {{ selectedDO && selectedDO.do_no }}</div>
            <div><b>Tanggal:</b> {{ deliveryDate }}</div>
            <div><b>Customer:</b> {{ customerName }}</div>
            <div><b>Delivery Address:</b> {{ deliveryAddress }}</div>
          </div>

          <table width="100%">
            <thead>
              <tr>
                <th>Nama Variant</th>
                <th>Label</th>
                <th>Volume</th>
              </tr>
            </thead>

            <tbody v-if="reportDetails && reportDetails.details">
              <tr
                v-for="(item, index) in reportDetails.details"
                :key="index"
              >
                <td>{{ item.name }}</td>

                <td>
                  <div v-if="item && item.color && item.color.color"
                    :style="{
                      width: '25px',
                      height: '25px',
                      background:item.color.color,
                      border: '1px solid #999'
                    }"
                  ></div>
                </td>

                <td>{{ item.size }} ML</td>
              </tr>
            </tbody>

          </table>

        </div>

      </section>
    </vue-html2pdf>

    <!-- LOADING -->
    <v-overlay :value="onLoad" z-index="999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

  </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
import { utils, writeFileXLSX } from 'xlsx';
export default {
  components: { VueHtml2pdf },
  data() {
    return {
      onLoad: false,

      deliveryDate: null,
      deliveryDateMenu: false,

      deliveryOrderData: [],
      selectedDO: null,

      customerName: '',
      deliveryAddress: '',

      reportDetails: null,

      showTable: false
    }
  },

  
  watch: {
    async deliveryDate(val) {
      if (val) await this.fetchDoByDate()
    },

    selectedDO(val) {
      if (!val) {
        this.customerName = ''
        this.deliveryAddress = ''
        return
      }
      this.customerName = val.customer_name || ''
      this.deliveryAddress = val.delivery_address || ''
    }
  },

  methods: {

    // GET DO BY DATE
    async fetchDoByDate() {
      this.onLoad = true
      try {
        const res = await this.$store.dispatch('deliveryorder/getObjs', {
          delivery_date: this.deliveryDate
        })

        this.deliveryOrderData = res?.data?.data || []

        this.selectedDO = null
        this.customerName = ''
        this.deliveryAddress = ''
        this.reportDetails = null

      } catch (error) {
        console.error(error)
      }
      this.onLoad = false
    },

    // LOAD DETAIL
   async runReport() {
    this.onLoad = true

    try {
            const detail = await this.$store.dispatch(
            'deliveryorder/getObj',
            this.selectedDO.do_no
            )

            this.reportDetails = detail

            this.showTable = true

        } catch (error) {
            console.error(error)
        } finally {
            this.onLoad = false
        }
    },

    exportReport() {
        console.log(this.$refs.tableDO.$el.firstChild.firstChild)
        const wb = utils.table_to_book(this.$refs.tableDO.$el.firstChild.firstChild)
        writeFileXLSX(wb, "Delivery-Order.xlsx")
    },
    exportPDF() {
      this.$refs.html2Pdf.generatePdf()
    }
  }
}
</script>

<style scoped>
table {
  border-collapse: collapse;
}

th, td {
  border: 1px solid #ddd;
  padding: 10px;
  font-size: 14px;
}

th {
  background: #f5f5f5;
}
.pdf-wrapper {
  padding: 30px 40px;
  box-sizing: border-box;
}
</style>
